export default {"src":"/_next/static/media/slider-btn-left.e9b08d87.svg","height":148,"width":148,"blurWidth":0,"blurHeight":0};